export default __webpack_public_path__ + "static/media/Flag_of_Russia.b4132869.svg";